import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am <span className="purple">Raushan Prasad </span>
            from <span className="purple"> Bihar, India.</span>
            <br />
            I am currently employed as a software developer at Koach.ai.
            <br />
            I have completed B.Tech in Computer Science and Engineering at Heritage Institute of Technology, Kolkata.
            <br />
            <br />
            Apart from coding, some other activities that I love to do!
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Playing Chess
            </li>
            <li className="about-activity">
              <ImPointRight /> Photography
            </li>
            <li className="about-activity">
              <ImPointRight /> Travelling
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "Everything happens for a reason!"{" "}
          </p>
          <footer className="blockquote-footer">Raushan</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
